import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import withSetting from '../SettingsHOC';
import { getActiveTokens } from '../../../ApiTokens/api-tokens.util';
import { isAdmin } from 'common/services/accounts.service';
import { RELEASE_DETECTION_OPTIONS } from './release-detection-settings.constants';
import { getAdditionalDataObject } from './release-detection-settings.util';
import RadioOption from '../view/RadioOption/RadioOption';
import { LBRadioGroup } from '@linearb/buzz';

const ReleaseDetectionSettings = ({
  onChange,
  value,
  wasReset,
  setWasReset,
  apiTokens,
  setApiTokens,
  account = {},
  toggleModal,
  toggleSnackBar,
  disabled
}) => {
  const [radioStates, setRadioStates] = useState({
    [value.key]: value.regex_pattern
  });
  const isAdminAccount = React.useMemo(() => isAdmin(account), [account]);
  const activeTokens = React.useMemo(
    () => getActiveTokens(apiTokens),
    [apiTokens]
  );
  const tokenExists = activeTokens && activeTokens.length;

  useEffect(() => {
    if (wasReset) {
      setRadioStates({ [value.key]: value.regex_pattern });
      setWasReset(false);
    }
  }, []);

  const onTokenGenerated = generateToken => {
    onChange({
      ...value,
      api_token_id: generateToken.id
    });
  };

  const handleRadioChange = radioValue => {
    const additionalDataObject = getAdditionalDataObject({
      radioStates,
      radioValue,
      tokenExists,
      activeTokens
    });
    onChange({
      ...value,
      key: radioValue,
      ...additionalDataObject
    });
  };

  const handleTextValueChange = e => {
    setRadioStates({
      ...radioStates,
      [value.key]: e.target.value
    });

    onChange({
      ...value,
      regex_pattern: e.target.value
    });
  };

  return (
    <LBRadioGroup onValueChange={handleRadioChange} value={value.key}>
      {_.map(RELEASE_DETECTION_OPTIONS, radioOption => (
        <RadioOption
          key={radioOption.radio_value}
          radioOption={radioOption}
          tokenExists={tokenExists}
          toggleModal={toggleModal}
          apiTokens={apiTokens}
          setApiTokens={setApiTokens}
          isAdminAccount={isAdminAccount}
          toggleSnackBar={toggleSnackBar}
          selectedRadio={value.key}
          onTokenGenerated={onTokenGenerated}
          handleRadioChange={handleRadioChange}
          handleValueChange={handleTextValueChange}
          textValue={radioStates[radioOption.radio_value]}
          optionBlocked={
            radioOption.adminOnly && !isAdminAccount && !tokenExists
          }
          value={value}
          account={account}
          disabled={disabled}
        />
      ))}
    </LBRadioGroup>
  );
};

export default withSetting(ReleaseDetectionSettings);
